import { Breadcrumb, BreadcrumbItem } from '@stuller/stullercom/ui'
import { type ReactElement } from 'react'

interface SerializedDiamondPageBreadcrumbsProps {
  activeBreadcrumbLabel: string
  isLabGrown: boolean
}

/**
 * Breadcrumbs for the Serialized Diamond Page
 */
function SerializedDiamondPageBreadcrumbs ({ activeBreadcrumbLabel, isLabGrown }: SerializedDiamondPageBreadcrumbsProps): ReactElement {
  const diamondsLink = isLabGrown ? '/lab-grown-diamonds/' : '/products/diamonds-with-grading-report/'

  return (
    <Breadcrumb className='mb-5'>
      <BreadcrumbItem href='/'>
        Home
      </BreadcrumbItem>
      <BreadcrumbItem href={diamondsLink}>
        Diamonds
      </BreadcrumbItem>
      <BreadcrumbItem active>
        {activeBreadcrumbLabel}
      </BreadcrumbItem>
    </Breadcrumb>
  )
}

export {
  SerializedDiamondPageBreadcrumbs
}
